/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Switch variables between \"For all sprites\" and \"For this sprite only\"",
  "description": "Adds more options when renaming an existing variable or list: allows changing between \"For all sprites\" and \"For this sprite only\" and whether variables are stored in the cloud. Also adds a new option when right clicking a variable/list to quickly change its scope.",
  "credits": [
    {
      "name": "GarboMuffin"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "tags": [],
  "dynamicEnable": true,
  "dynamicDisable": true,
  "enabledByDefault": false
};
export default manifest;
